import Vue from 'vue';
import Rollbar from 'vue-rollbar';

const isProduction = process.env.VUE_APP_ENV === 'production';

Vue.use(Rollbar, {
  accessToken: process.env.VUE_APP_ROLLBAR_TOKEN,
  hostSafeList: ['motionelements.com', 'cloudfront.net'],
  captureUncaught: !isProduction,
  captureUnhandledRejections: !isProduction,
  verbose: !isProduction,
  enabled: !['development'].includes(process.env.VUE_APP_ENV), // true,
  environment: process.env.VUE_APP_ENV,
});

Vue.config.errorHandler = function (err, vm) {
  if (!isProduction) {
    vm.$rollbar.error(err);
  }
};
